export default __webpack_public_path__ + "static/media/banner-company.cdf5b6bb.png";